import { ReactComponent as RightSvg } from '../../../images/manifold/right.paths.svg';

type Props = {
  xTransform: number;
  yTransform: number;
};

export const RightPaths = ({ xTransform, yTransform }: Props) => {
  return (
    <g transform={`matrix(0, -1, 1, 0, ${xTransform} , ${yTransform})`}>
      <RightSvg />
    </g>
  );
};
